module.exports = __webpack_public_path__ + "img/checkmark-circle.dce9225d.svg";